import { InputBase, styled } from "@mui/material";

const CustomTextField = styled(InputBase)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "0 0px 8px 0 rgba(0, 0, 0, 0.17)",
  padding: "8px 16px",
  fontSize: "1em",
  borderRadius: 4,
  background: "#FFFFFF",
}));

export default CustomTextField;
